_options$series3